import { alpha } from '@mui/material';
import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import { shadows } from '@client/theme/shadows';
import type { ThemeOptions } from '@mui/material';

const Checkbox: ThemeOptions['components'] = {
  MuiCheckbox: {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      root: ({ ownerState }) => ({
        padding: 0,
        backgroundColor: palette.grey[300],
        color: palette.grey[50],
        minHeight: 20,
        minWidth: 20,
        borderRadius: '50%',

        '&:hover': {
          boxShadow: shadows[2],
        },

        '& + span, & + .MuiStack-root': {
          marginLeft: theme.spacing(1),
        },

        '&.Mui-disabled + span': {
          color: palette.text.disabled,
        },

        '& svg': {
          fontSize: 18,
          lineHeight: '18px',
          display: 'none',
          marginTop: 1,
        },

        '&.Mui-checked': {
          backgroundColor: palette[ownerState.color].main,
          color: palette.grey[50],

          '& svg': {
            display: 'block',
          },

          '&.Mui-disabled': {
            backgroundColor: alpha(palette[ownerState.color].main, 0.5),
          },
        },
      }),
    },
  },
  MuiRadio: {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      root: ({ ownerState }) => ({
        padding: 0,
        backgroundColor: palette.grey[300],
        color: palette.grey[50],
        minHeight: 20,
        minWidth: 20,

        '&:hover': {
          boxShadow: shadows[2],
        },

        '& + span': {
          marginLeft: theme.spacing(1),
        },

        '&.Mui-disabled + span': {
          color: palette.text.disabled,
        },

        '& svg': {
          fontSize: 20,
          lineHeight: '20px',
          display: 'none',
        },

        '&.Mui-checked': {
          backgroundColor: palette[ownerState.color].main,

          '& svg': {
            display: 'block',
          },
        },
      }),
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        padding: theme.spacing(2),
        height: 44, // Default switch padding is 12px and height is 34px - we're adding 8px of padding
        width: theme.spacing(9),
      },
      switchBase: {
        padding: 0,
        color: palette.grey[400],

        '&.Mui-checked': {
          color: palette.grey[400],
          transform: 'translateX(30px)',
        },
      },
      colorPrimary: {
        color: palette.primary.main,

        '&:hover': {
          color: palette.primary.main,
        },

        '&.Mui-checked': {
          color: palette.primary.main,
        },

        '&.Mui-disabled': {
          color: `${alpha(palette.primary.main, 0.6)} !important`,
        },
      },
      colorSecondary: {
        color: palette.grey[400],

        '&:hover': {
          color: palette.grey[400],
        },

        '&.Mui-checked': {
          color: palette.primary.main,

          '&:hover': {
            color: palette.primary.main,
          },
        },

        '&.Mui-disabled': {
          color: `${alpha(palette.primary.main, 0.6)} !important`,
        },
      },
      thumb: {
        transform: 'translateY(-2px)',
      },
      track: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: palette.grey[300],
        backgroundColor: `${palette.grey[200]} !important`,
      },
    },
  },
};

export default Checkbox;
